import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';

export default {
  preparePersonEntity(values) {
    const person = {
      type: 'Person',
      id06: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      city: '',
      companyId: '',
      username: '',
      userId: '',
      passwordReset: false,
      role: '',
      occupation: '',
      projects: [],
      archived: false,
      lastCommentReadDate: '0000-01-01 00:00:00',
      lastLoginDate: '0000-01-01 00:00:00',
      nextOfKin: '',
      nextOfKinPhone: '',
      supervisor: '',
      supervisorPhone: '',
      allergiesAndDiseases: '',
      languages: [],
      ...(typeof values === 'object' && values != null ? values : {}),
    };

    if (!person.createdAt) {
      // Calling moment() is pretty expensive so it's better to minimize number of calls for operations that call this
      // method many times, such as `fetchPersons`.
      person.createdAt = moment().format();
    }

    return person;
  },

  async createPerson(personData) {
    log.debug('personApi:createPerson', personData);

    const person = this.preparePersonEntity(personData);
    const doc = await db.organisationDb.post(person);
    person._id = doc.id;
    person._rev = doc.rev;

    return person;
  },

  async savePerson(person, reason) {
    log.debug('personApi:savePerson', person, reason);
    const isCreate = !person._id;
    const response = await (isCreate ? db.organisationDb.post(person, reason) : db.organisationDb.put(person, reason));

    return isCreate ? { _id: response.id, _rev: response.rev } : { _rev: response.rev };
  },

  async fetchPersons() {
    try {
      const result = await db.organisationDb.query('personList', { include_docs: true });
      const persons = {};
      result.rows.forEach(({ doc }) => {
        persons[doc._id] = this.preparePersonEntity(doc);
      });

      return persons;
    } catch (error) {
      log.error('personApi:fetchPersons - Unable to load persons', error);
    }
  },

  async getPersonFiles(personId) {
    if (personId == null) {
      return;
    }

    try {
      const params = { key: personId, limit: 1, include_docs: true };
      const { rows } = await db.organisationDb.query('PersonFiles/by_personId', params);
      const row = rows && rows.find(({ doc }) => doc.personId === personId);

      return row && row.doc;
    } catch (error) {
      log.error('personApi:getPersonFiles - Unable to load person files', error);
    }
  },

  async savePersonFile(personId, fileName, fileData) {
    try {
      const doc = await this.getPersonFiles(personId);
      if (!doc) {
        return db.organisationDb.post({ type: 'PersonFiles', personId, filesLinks: fileData ? [fileData] : [] });
      }

      const files = doc.filesLinks ? [...doc.filesLinks] : [];
      const index = files.findIndex((item) => item.fileName === fileName);
      if (index >= 0) {
        files.splice(index, 1);
      }
      if (fileData) {
        files.push(fileData);
      }

      return db.organisationDb.put({ ...doc, filesLinks: files });
    } catch (error) {
      log.error('personApi:savePersonFile - Unable to save person files', error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/person/personApi.js